import React, { useEffect } from 'react'
import ContactBanner from './ContactBanner'
import ContactForm from './ContactForm';
import Talktoustabs from './Talktoustabs';
// import ContactMap from './ContactMap'
import Footer from './Footer';

const Talsktous = () => {
       // Scroll to the top of the page when the component mounts
       useEffect(() => {
        window.scrollTo(0, 0);
      }, []); // Empty dependency array ensures it only runs once when the component mounts
    
  return (
    <div style={{background:"#fff"}}>
        <br></br><br></br>
        {/* <ContactBanner/> */}
        <Talktoustabs />
        {/* <ContactForm/> */}
        {/* <ContactMap/> */}
        <Footer />
        <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default Talsktous;